import React from 'react';
import {ThemeProvider} from 'styled-components';

import {defaultTheme} from './src/styleguide/DefaultTheme';

export function wrapPageElement({element}) {
  return <ThemeProvider theme={defaultTheme}>{element}</ThemeProvider>;
}
